import { useContext, createContext, useState } from "react";


const ViewContext = createContext();


const ViewProvider = ({children, ...rest}) =>
{

    const [viewFilter, setViewFilter] = useState({});
    const [viewValue, setViewValue] = useState({});

    const [tableData, setTableData] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
  

    const value = { 
        viewFilter, setViewFilter,
        viewValue, setViewValue,
    }

    return(    
        <ViewContext.Provider  value={value}>
            {children}
        </ViewContext.Provider>)  
}

export default ViewProvider;

export const useViewContext=()=> {
    return useContext(ViewContext);
}

